interface AXISXY {
  x: {
    pos: number;
    value: number;
  };
  y: {
    pos: number;
    value: number;
  };
}

interface Props {
  position: AXISXY;
  element: any;
}

const setAxis = ({ position, element }: Props) => {
  if (!element) return;

  element.style.top = `${position.y.pos}%`;
  element.style.left = `${position.x.pos}%`;
  element.style.width = `${position.x.value}px`;
  element.style.height = `${position.y.value}px`;

  return element;
};

export default setAxis;
